<template>
  <div v-if="shouldShow" class="leaderboard-row">
    <LeaderboardCell
        :cellContent="{show: shouldShow, set: set, type: 'index', index: index, isSelf:info.isBuddy, text: index+1}"></LeaderboardCell>
    <LeaderboardCell
        :cellContent="{show: shouldShow, set: set, type: 'buddyName', index: index, isSelf:info.isBuddy, text: info.buddyName}"></LeaderboardCell>
    <LeaderboardCell
        :cellContent="{show: shouldShow, set: set, type: 'activityCount', index: index, isSelf:info.isBuddy, text: info.activityCount}"></LeaderboardCell>
    <LeaderboardCell
        :cellContent="{show: shouldShow, set: set, type: 'class', index: index, isSelf:info.isBuddy, text: info.class}"></LeaderboardCell>
    <LeaderboardCell
        :cellContent="{show: shouldShow, set: set, type: 'school', index: index, isSelf:info.isBuddy, text: info.school}"></LeaderboardCell>
    <LeaderboardCell
        :cellContent="{show: shouldShow, set: set, type: 'city', index: index, isSelf:info.isBuddy, text: info.city}"></LeaderboardCell>
  </div>
</template>

<script>

import LeaderboardCell from "@/components/StudentPlatform/Leaderboard/LeaderboardCell.vue";

export default {
  name: "LeaderboardRow",
  components: {LeaderboardCell},
  props: {
    info: Object,
    set: String,
    show: Boolean,
    buddy: Object,
    index: Number,
  },
  data() {
    return {}
  },
  computed: {
    shouldShow() {
      return this.show;
    }
  },

  mixins: [],
  methods: {},
  mounted() {

  },
  created() {

  }
}


</script>

<style lang="scss" scoped>

.leaderboard-row {
  padding: 0% 1% 1%;
  height: 10%;
  display: flex;
  flex-direction: row;
  gap: 10px;

  p {
    font-family: "Flanders Art Sans", sans-serif;
    font-weight: bold;
    color: #fff;
    margin: 0;
  }
}

.index, .buddyName, .activitiesCount, .class, .school, .city {
  height: 100%;
  position: relative;
  padding: 0 3%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


.leaderboard-content.school {
  .index {
    width: 5%;
  }

  .buddyName {
    width: 30%;
  }

  .activityCount {
    width: 15%;
  }

  .class {
    width: 50%;
  }

}

.leaderboard-content.vlaanderen {
  .index {
    width: 5%;
  }

  .buddyName {
    width: 25%;
  }

  .activityCount {
    width: 12%;
  }

  .school {
    width: 40%;
  }

  .city {
    width: 18%;
  }
}





</style>